import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const TitleContentBlocksGrid = ({
  key,
  heading=null,
  contentBlocks=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <div className="title-with-content-blocks-grid row d-flex jcc">
      <div className="col-xs-12 col-lg-10 col-xl-9 d-flex flex-wrap blocks-title-wrap">
        <div className="row">
        <div className="d-flex col-xs-12 col-md-6 aic">
          <div className="content-inner">
            {heading &&
              <h2 className="three-blocks-main-title ph.5">{ htmlDecode(heading) }</h2>
            }
            <span className="orange-line-after" />
          </div>
        </div>
        {contentBlocks && contentBlocks.map((contentBlock) => (
          <div className="content-block-wrap d-flex col-xs-12 col-md-6">
            {contentBlock?.button?.link &&
              <Link href={ contentBlock.button.link } className="d-flex flex-wrap ph.5">
                <div className="content-inner-all mv1 d-flex bgw bs1">
                  <div className="col-12 col-lg-11 content-block-inner">
                    <span className="subtitle">{ htmlDecode(contentBlock.subTitle) }</span>
                    <h3 className="title">{ htmlDecode(contentBlock.title) }</h3>
                    <span className="content" dangerouslySetInnerHTML={{ __html: contentBlock.content }} />
                    <span className="link">{ contentBlock.button.text }</span>
                  </div>
                  <div className="bg-img d-flex aife">
                    {contentBlock.image.formats.medium &&
                      <img src={contentBlock.image.formats.medium.url.includes(cdnUrl) ? contentBlock.image.formats.medium.url : cdnUrl + contentBlock.image.formats.medium.url} alt={ contentBlock.image?.alternativeText } />
                    }
                    {!contentBlock.image.formats.medium &&
                      <img src={contentBlock.image.url.includes(cdnUrl) ? contentBlock.image.url : cdnUrl + contentBlock.image.url} alt={ contentBlock.image?.alternativeText } />
                    }
                  </div>
                </div>
              </Link>
            }
            {!contentBlock?.button?.link &&
              <div className="d-flex flex-wrap ph.5">
                <div className="content-inner-all mv1 d-flex bgw bs1">
                  <div className="col-12 col-lg-11 content-block-inner">
                    <span className="subtitle">{ htmlDecode(contentBlock.subTitle) }</span>
                    <h3 className="title">{ htmlDecode(contentBlock.title) }</h3>
                    <span className="content" dangerouslySetInnerHTML={{ __html: contentBlock.content }} />
                    <span className="link">{ contentBlock.button.text }</span>
                  </div>
                  <div className="bg-img d-flex aife">
                    {contentBlock.image.formats.medium &&
                      <img src={contentBlock.image.formats.medium.url.includes(cdnUrl) ? contentBlock.image.formats.medium.url : cdnUrl + contentBlock.image.formats.medium.url} alt={ contentBlock.image?.alternativeText } />
                    }
                    {!contentBlock.image.formats.medium &&
                      <img src={contentBlock.image.url.includes(cdnUrl) ? contentBlock.image.url : cdnUrl + contentBlock.image.url} alt={ contentBlock.image?.alternativeText } />
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        ))}
        </div>
      </div>
    </div>
  )
}

export default TitleContentBlocksGrid
